var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import SessionTimerModalState from './SessionTimerModalState';
import * as SessionTimerStyle from './SessionTimerModal.scss';
import { Modal, Button, RichText, Heading } from '@idp/ui-components';
import { CMS } from '@idp/cms-integration';
import { ButtonType } from '@idp/ui-components/components/atoms/Button/ButtonProps';
import { Types } from '@idp/ui-components/components/atoms/Heading/HeadingProps';
import getTestId from '@idp/ui-components/utils';
import { SessionTimerModalCms } from './SessionTimerModal.cms';
import { offersService } from '../../services/Offers.service';
import { keepAlive, setupListeners, stopWorker, unregisterUserActivity, userTimeStampKey, oldUserTimeStampKey, maximumUserWaitTimeKey, threshHoldTimeKey } from '../../services/keepAlive';
import { ICCEventBusManager } from '@idp/event-bus';
import { LobStateManagerNameSpaces } from '../MainView/MainView.container.props';
import { getCMSFeedName } from '../../utils/UtilityFunctions';
import { StateProvider } from '../../services/state-provider';
import { LinkPositionDataKeysOptions, EventActions } from '../../services/AnalyticsEvents';
import ReportingGateway from '../../services/ReportingGateway';
var SessionTimerModal = /** @class */ (function (_super) {
    __extends(SessionTimerModal, _super);
    function SessionTimerModal(props) {
        var _this = _super.call(this, props) || this;
        _this.heartBeatAPIURI = '/msapi/ska';
        // Max Wait Time Minute Factor
        _this.waitTimeFactor = 30 * 60 * 1000;
        // Max Threshold Time Minute Factor
        _this.threshTimeFactor = 5 * 60 * 1000;
        _this.observerId = '';
        _this.showExpiryModalAfterRedirectionKey = 'showExpiryModalAfterRedirection';
        _this.onContinuation = function () {
            _this.setState({ timeOut: false });
            _this.firePageLoadForTimerModal();
            _this.callHeartBeatAPI();
            if (_this.props.events && _this.props.events.onContinueCTAClick) {
                _this.props.events.onContinueCTAClick();
            }
        };
        _this.onExpiration = function () {
            _this.setState({ timeOut: false, expiredTimeOut: false }, function () {
                _this.firePageLoadForTimerModal();
                if (_this.props.events && _this.props.events.onExpireCTAClick) {
                    _this.props.events.onExpireCTAClick();
                }
                if (!_this.state.doNoRedirection) {
                    _this.callRedirectAPI();
                }
            });
        };
        _this.onCloseTimerModal = function () {
            _this.setState({ timeOut: false, expiredTimeOut: false });
            _this.fireCloseForTimerModal();
            if (_this.props.events && _this.props.events.onModalClose) {
                _this.props.events.onModalClose();
            }
        };
        _this.state = new SessionTimerModalState();
        _this.stateManager = StateProvider.getStateManagerInstance();
        _this.bindAll();
        _this.initializeEvents();
        return _this;
    }
    SessionTimerModal.prototype.componentWillMount = function () {
        stopWorker();
        localStorage.removeItem(userTimeStampKey);
        localStorage.removeItem(oldUserTimeStampKey);
        localStorage.removeItem(maximumUserWaitTimeKey);
        localStorage.removeItem(threshHoldTimeKey);
        this.cmsDataAttrName = getCMSFeedName();
        this.getCMSContent();
        this.setState({ redirectURL: this.props.data.redirectURL });
        var sessionData = this.stateManager && this.stateManager.get('appShell', this.showExpiryModalAfterRedirectionKey);
        if (sessionData && sessionData.showModal) {
            this.stateManager.remove(this.showExpiryModalAfterRedirectionKey);
            this.setState({ timeOut: true, expiredTimeOut: true, doNoRedirection: true });
        }
    };
    SessionTimerModal.prototype.render = function () {
        if (this.state.timeOut) {
            return (React.createElement(Modal, { options: { show: this.state.timeOut, showClose: !this.state.expiredTimeOut, disableEscape: true }, events: { onClose: this.onCloseTimerModal } },
                React.createElement("div", { className: SessionTimerStyle.modal, id: "modalContent" },
                    React.createElement(Heading, { data: { text: this.state.expiredTimeOut ? this.cmsData.expiredHeadingText : this.cmsData.headingText }, options: {
                            className: 'abc',
                            tabIndex: 0,
                            type: Types.H2,
                        } }),
                    React.createElement("div", { className: SessionTimerStyle.modalContent },
                        React.createElement(RichText, { testId: getTestId('TimerModal', 'Label', '_content'), data: { text: this.state.expiredTimeOut ? this.cmsData.expiredModalContent : this.cmsData.modalContent, isDecodingRequired: false } })),
                    React.createElement(Button, { testId: getTestId('TimerModal', 'Button', 'Continue'), data: { text: this.state.expiredTimeOut ? this.cmsData.cancelButtonText : this.cmsData.continueButtonText }, events: this.state.expiredTimeOut ? this.expiredButtonEvents : this.continueButtonEvents, options: {
                            type: ButtonType.PRIMARY,
                        } }))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    SessionTimerModal.prototype.componentDidMount = function () {
        this.registerObservers();
        this.startKeepAliveListener(false);
    };
    SessionTimerModal.prototype.componentWillUnmount = function () {
        ICCEventBusManager.getInstance().deregisterObserver(this.observerId);
        stopWorker();
        localStorage.removeItem(userTimeStampKey);
        localStorage.removeItem(oldUserTimeStampKey);
        localStorage.removeItem(maximumUserWaitTimeKey);
        localStorage.removeItem(threshHoldTimeKey);
    };
    SessionTimerModal.prototype.bindAll = function () {
        this.firePageLoadForTimerModal = this.firePageLoadForTimerModal.bind(this);
        this.fireCloseForTimerModal = this.fireCloseForTimerModal.bind(this);
        this.callHeartBeatAPI = this.callHeartBeatAPI.bind(this);
        this.initializeEvents = this.initializeEvents.bind(this);
        this.onContinuation = this.onContinuation.bind(this);
        this.onExpiration = this.onExpiration.bind(this);
        this.callRedirectAPI = this.callRedirectAPI.bind(this);
        this.onCloseTimerModal = this.onCloseTimerModal.bind(this);
        this.startKeepAliveListener = this.startKeepAliveListener.bind(this);
        this.registerObservers = this.registerObservers.bind(this);
        this.getCMSContent = this.getCMSContent.bind(this);
        this.executeExpirytimerLogic = this.executeExpirytimerLogic.bind(this);
    };
    SessionTimerModal.prototype.initializeEvents = function () {
        this.continueButtonEvents = {
            onClick: this.onContinuation.bind(this),
        };
        this.expiredButtonEvents = {
            onClick: this.onExpiration.bind(this),
        };
    };
    SessionTimerModal.prototype.callHeartBeatAPI = function () {
        var _this = this;
        // tslint:disable-next-line:no-any
        return offersService.fetchData(this.heartBeatAPIURI).then(function (data) {
            stopWorker();
            _this.startKeepAliveListener(false);
        }).catch(function (err) {
            if (_this.props.events && _this.props.events.onApiFailure) {
                _this.props.events.onApiFailure();
            }
            stopWorker();
            _this.startKeepAliveListener(true);
        });
    };
    SessionTimerModal.prototype.callRedirectAPI = function () {
        window.location.href = this.state.redirectURL;
    };
    SessionTimerModal.prototype.firePageLoadForTimerModal = function () {
        var addData = {
            additionalData: {
                url: '/timer/modal',
            },
            eventAction: EventActions.PAGE_LOAD,
            eventCode: 'Page_Load',
        };
        ReportingGateway.sendReportingEvent(addData);
    };
    SessionTimerModal.prototype.fireCloseForTimerModal = function () {
        var addData = {
            additionalData: {
                linkDestinationUrl: '/timer/modal',
                linkName: 'Close Modal',
                linkPosition: LinkPositionDataKeysOptions.HEADER,
            },
            eventAction: EventActions.LINK_CLICK,
            eventCode: 'Link_Click',
        };
        ReportingGateway.sendReportingEvent(addData);
    };
    SessionTimerModal.prototype.startKeepAliveListener = function (useExistingTime) {
        // time stamp the user
        var userTimeStamp = new Date().getTime();
        localStorage.setItem(userTimeStampKey, userTimeStamp.toString());
        localStorage.removeItem(oldUserTimeStampKey);
        if (!useExistingTime) {
            // Maximum wait time - minutes
            this.maximumUserWaitTime = userTimeStamp + (this.waitTimeFactor);
            localStorage.setItem(maximumUserWaitTimeKey, this.maximumUserWaitTime.toString());
            // Thresh-hold time : minutes - maximumUserWaitTime - thresh wait
            this.threshHoldTime = this.maximumUserWaitTime - (this.threshTimeFactor);
            localStorage.setItem(threshHoldTimeKey, this.threshHoldTime.toString());
        }
        setupListeners();
        var self = this;
        keepAlive(self.maximumUserWaitTime, self.threshHoldTime)
            .then(function (res) {
            if ((res === 1) || (self.state.timeOut && !self.state.expiredTimeOut && (res === 2))) {
                self.setState({ timeOut: true, expiredTimeOut: false }, function () {
                    if (self.props.events && self.props.events.onContinueModalDisplay) {
                        self.props.events.onContinueModalDisplay(self.cmsData.modalContent);
                    }
                    stopWorker();
                    unregisterUserActivity();
                    self.startKeepAliveListener(true);
                });
            }
            else if (res === 2) {
                self.callHeartBeatAPI();
            }
            else if (res === 3) {
                self.executeExpirytimerLogic();
            }
        })
            .catch(function (err) {
            // do nothing.. no need to start the listeners again
            // because browser do not support it
            self.setState({ timeOut: false, expiredTimeOut: false });
            unregisterUserActivity();
        });
    };
    SessionTimerModal.prototype.registerObservers = function () {
        var _this = this;
        this.observerId = ICCEventBusManager.getUUID();
        // Observer for all LOB to show Expired Modal
        var lobList = LobStateManagerNameSpaces;
        lobList.forEach(function (lob) {
            var observer = {
                eventHandler: _this.executeExpirytimerLogic,
                observerId: _this.observerId,
                serviceName: lob + ':sessionExpired',
            };
            ICCEventBusManager.getInstance().registerObserver(observer);
        });
    };
    SessionTimerModal.prototype.getCMSContent = function () {
        if (!this.cmsData || !this.cmsData.headingText) {
            this.cmsData = this.cmsDataAttrName ? CMS.get(new SessionTimerModalCms(), this.cmsDataAttrName).content.sessionTimerModal : new SessionTimerModalCms();
            if (!this.cmsData || !this.cmsData.headingText) {
                this.cmsData = new SessionTimerModalCms();
            }
        }
    };
    SessionTimerModal.prototype.executeExpirytimerLogic = function () {
        var _this = this;
        if (this.props.options && this.props.options.showExpiryModalAfterRedirection) {
            if (this.props.events && this.props.events.onExpiryModalDisplay) {
                this.props.events.onExpiryModalDisplay(this.cmsData.expiredModalContent, true);
            }
            sessionStorage.clear();
            this.stateManager.set(this.showExpiryModalAfterRedirectionKey, { showModal: true });
            this.callRedirectAPI();
        }
        else {
            this.setState({ timeOut: true, expiredTimeOut: true }, function () {
                if (_this.props.events && _this.props.events.onExpiryModalDisplay) {
                    _this.props.events.onExpiryModalDisplay(_this.cmsData.expiredModalContent, true);
                }
                sessionStorage.clear();
            });
        }
    };
    return SessionTimerModal;
}(React.Component));
export default SessionTimerModal;
//# sourceMappingURL=SessionTimerModal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/SessionTimerModal/SessionTimerModal.js
// module id = 1729
// module chunks = 8